var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"id":"exclusive-control","title":""},on:{"ok":_vm.ok}},[[_vm._v("\n    一時的にデータを更新できませんでした。もう一度操作をやり直してください。\n  ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }